import {
  SAVE_CLIENTS_LIST,
  SAVE_CLIENT_DETAILS
} from 'redux/constants/Clients';

const theme = (state = {}, action) => {
  switch (action.type) {
  case SAVE_CLIENTS_LIST:
    return {
      ...state,
      list: action.payload
    };
  case SAVE_CLIENT_DETAILS:
    return {
      ...state,
      details: action.payload
    };
  default:
    return state;
  }
};

export default theme